import RecommendedItineraryBuilder from './RecommendedItineraryBuilder';
import FastestItineraryBuilder from './FastestItineraryBuilder';
import CheapestItineraryBuilder from './CheapestItineraryBuilder';
import WithBaggageItineraryBuilder from './WithBaggageItineraryBuilder';
import CheapestPrimeDayDealItineraryBuilder from './CheapestPrimeDayDealItineraryBuilder';
import EarliestItineraryBuilder from './EarliestItineraryBuilder';
import EarliestFlightItineraryBuilder from './EarliestFlightItineraryBuilder';

const BestItinerariesBuilder = () => {
  const cheapestBuilder = CheapestItineraryBuilder();
  const recommendedBuilder = RecommendedItineraryBuilder();
  const fastestBuilder = FastestItineraryBuilder();
  const withBaggageBuilder = WithBaggageItineraryBuilder();
  const cheapestPrimeDayDealBuilder = CheapestPrimeDayDealItineraryBuilder();
  const earliestItineraryBuilder = EarliestItineraryBuilder();
  const earliestFlightItineraryBuilder = EarliestFlightItineraryBuilder();

  return {
    add(itinerary, position) {
      cheapestBuilder.add(itinerary, position);
      recommendedBuilder.add(itinerary, position);
      fastestBuilder.add(itinerary, position);
      withBaggageBuilder.add(itinerary, position);
      cheapestPrimeDayDealBuilder.add(itinerary, position);
      earliestItineraryBuilder.add(itinerary, position);
      earliestFlightItineraryBuilder.add(itinerary, position);
    },
    build() {
      const recommended = recommendedBuilder.build();
      const cheapest = cheapestBuilder.build();
      const fastest = fastestBuilder.build();
      const withBaggage = withBaggageBuilder.build();
      const primeDay = cheapestPrimeDayDealBuilder.build();
      const earliest = earliestItineraryBuilder.build();
      const earliestFlight = earliestFlightItineraryBuilder.build();

      return [
        recommended,
        cheapest,
        fastest,
        withBaggage,
        primeDay,
        earliest,
        earliestFlight,
      ];
    },
  };
};

export default BestItinerariesBuilder;
